export type PreviewKind = 'image' | 'pdf' | 'other';

const IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif']);

const MIME_BY_EXT: Record<string, string> = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export function fileExtension(name: string): string {
  const parts = name.split('.');
  if (parts.length < 2) return '';
  return parts.pop()?.toLowerCase() || '';
}

export function previewKindFromName(name: string): PreviewKind {
  const ext = fileExtension(name);
  if (IMAGE_EXT.has(ext)) return 'image';
  if (ext === 'pdf') return 'pdf';
  return 'other';
}

export function mimeFromName(name: string): string {
  return MIME_BY_EXT[fileExtension(name)] || 'application/octet-stream';
}

export function blobWithMime(blob: Blob, name: string): Blob {
  const mime = mimeFromName(name);
  if (blob.type && blob.type !== 'application/octet-stream') {
    return blob;
  }
  return new Blob([blob], { type: mime });
}
